<script setup>
defineProps({
    count:   { type: Number, default: 0 },
    variant: { type: String, default: 'brand' }, // 'brand' | 'warn'
})
</script>

<template>
    <span
        class="text-[11px] font-bold px-2 py-0.5 rounded-full"
        :class="{
            'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400': variant === 'brand',
            'bg-orange-50 dark:bg-orange-950 text-[#D9663A] dark:text-orange-400': variant === 'warn',
        }"
    >{{ count }}</span>
</template>
